import { JobMatchProfileOnConferenceComponent } from "./job-match-profile-on-conference.component";
export const JobMatchProfileOnConferenceModule = angular
    .module('jobMatchProfileOnConference', [])
    .component(JobMatchProfileOnConferenceComponent.selector, JobMatchProfileOnConferenceComponent.component)
    .name;
//# sourceMappingURL=job-match-profile-on-conference.module.js.map